import client from './client'

export const fetchShopProducts = (params = {}) => client.get('/shop/products', { params })

export const fetchShopProduct = (id) => client.get(`/shop/products/${id}`)

export const fetchShopCategories = () => client.get('/shop/categories')
